import { adaniLrRateImport, jklrRateImport, lrRateImport, planImport } from "_services";
import {
  getBranchDropdownListData,
  getConsignorDropdownListData,
  getConsignorDropdownListData2,
  getContractDropdownListData,
} from "_services/dropdownServices/dropdownService";
import { ButtonExcelForQuick, CityDropdownForTrip, CommonInput, CustomSelect, ExcelDownload, Heading } from "components";
import { errorSchema, utils } from "helper";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import StorageService from "utils/StorageServices";

const LRUpload = () => {

  const [searchParams] = useSearchParams();
  const id = searchParams.get('id'); // "1"
  const initial = {
    company_id: StorageService?.getCompanyId(),
    consignor_id: "",
    contract_id: "",
    branch_id: "",
    file: null,
  };
  const navigate = useNavigate();
  const [form, setForm] = useState(initial);
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const [consignorList, setConsignorList] = useState([]);
  const [listData, setListData] = useState({
    consignorList: [],
    contractList: [],
    branchList: [],
  });
  const [hasMoreVehicle, setHasMoreVehicle] = useState(true);
  const [page, setPage] = useState(1);
  const [planInportList, setPlanInportList] = useState([])
  const [tableData, setTableData] = useState([])
  const [statusCounts, setStatusCounts] = useState({
    Rejected: 0,
    Updated: 0,
    Added: 0,
    All: 0,
  });
  useEffect(() => {
    // fetchPartyList();
    fetchBranchList()
  }, []);

  useEffect(() => {
    if (form?.consignor_id) {
      getContractList(form?.consignor_id?.value);
    }
  }, [form?.consignor_id]);

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
        ...(name === "branch_id" && { consignor_id: "" }),
      };

      if (formError) {
        utils
          .checkFormError(
            { ...updatedForm },
            errorSchema.lrImportSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };


  //file

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (validTypes.includes(file.type)) {
        handleOnChange("file", file);
        setFormError({
          ...formError,
          file: "",
        });
      } else {
        setFormError({
          ...formError,
          file: "Please upload only CSV or XLSX files.",
        });
      }
    }
  };

  //common Api function
  const commonFetchFuction = async (
    apiMethod,
    payload = {},
    transformer = (res) => res
  ) => {
    try {
      const res = await apiMethod(payload);
      if (res?.responseCode === 200) {
        return transformer(res);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  //common formate for dropdown

  const formatList = (list, labelKey, valueKey, defaultOption = null) => {
    const formattedList = list?.map((item) => ({
      ...item,
      label: item[labelKey],
      value: item[valueKey],
    }));
    return defaultOption
      ? [{ label: defaultOption, value: "" }, ...formattedList]
      : formattedList;
  };

  //set initial value

  const setInitialFormValues = (name, value) => {
    handleOnChange(name, value || "");
  };

  const fetchBranchList = async () => {
    const branchRes = await commonFetchFuction(getBranchDropdownListData, {
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      limit: 1000,
      offset: 1,
    });
    if (branchRes?.responseCode === 200) {
      const formattedBranchList = formatList(branchRes?.data?.branch_list, "branch", "_id");
      setListData((prev) => ({
        ...prev,
        branchList: formattedBranchList,
      }));

      // Set default branch only once
      if (!form.branch_id && formattedBranchList.length > 0) {
        setInitialFormValues("branch_id", formattedBranchList[0]);
      }
    }
  };


  const fetchConsignor = async (search, page, limit) => {
    const res = await getConsignorDropdownListData2({
      company_id: StorageService.getCompanyId(),
      firm_id: form?.branch_id?.firm_id?._id,
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.consignor_list.map((c) => ({ ...c, value: c._id, label: c.name }))
      if (page == 1) {
        // setConsignorList(list);
        if (!form?.consignor_id) {
          setInitialFormValues(
            "consignor_id",
            list[0]
          );
        }
      }
      return {

        items: [...list],

        total: res?.data?.total_record,
      };

    } else {
      toast.error(res?.responseMessage);
    }
  };

  const getContractList = async (contarct) => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      consignor_id: contarct,
      limit: 1000,
      offset: 1,
      search: "",
    };
    try {
      const contractRes = await commonFetchFuction(
        getContractDropdownListData,
        payload
      );

      setListData((prev) => ({
        ...prev,
        contractList: formatList(
          contractRes?.data?.contract_list,
          "name",
          "_id"
        ),
      }));

      const activeContract = contractRes?.data?.contract_list?.find((i) => i.active == 1);
      if (activeContract) {
        setInitialFormValues("contract_id", activeContract._id);
      }

    } catch (error) {
      toast.error("Error fetching data", error);
    }
  };



  const handleImportFile = async () => {
    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      if (key === "branch_id" && form[key]) {
        formData.append(key, form[key].value);
      } else if (key === "consignor_id" && form[key]) {
        formData.append(key, form[key].value);
      } else if (key === "file" && form[key]) {
        formData.append(key, form[key]);
      } else if (form[key] !== undefined && form[key] !== null) {
        formData.append(key, form[key]);
      }
    });
    const validationResult = await utils.checkFormError(
      { ...form, branch_id: form?.branch_id?._id },
      errorSchema.lrImportSchema
    );

    if (validationResult == true) {
      setLoading(true);
      try {
        const res = id == 1 ? await lrRateImport(formData) : id == 2 ? await jklrRateImport(formData) : id == 3 ? await adaniLrRateImport(formData) : await lrRateImport(formData);;
        if (res?.responseCode == 200) {
          setLoading(false);

          setPlanInportList(res?.data?.results)
          toast?.success(res?.responseMessage);

          const execleDat = res?.data?.results?.map((i) => {

            return {
              "Unit": `${i?.value?.unit_code || ""}${i?.value?.unit_code && i?.value?.unit_name ? " | " : ""}${i?.value?.unit_name || ""}`,
              "Consignee": `${i?.value?.consignee_code || ""}${i?.value?.consignee_code && i?.value?.consignee_name ? " | " : ""}${i?.value?.consignee_name || ""}`,
              "status": i?.status || "",
              "remark": i?.remarks || ""

            }
          })
          const counts = res?.data?.results.reduce(
            (acc, item) => {
              if (item.status === 'Not Updated') acc.Rejected++;
              if (item.status === 'Updated') acc.Updated++;
              if (item.status === 'Added') acc.Added++;
              acc.All++;
              return acc;
            },
            { Rejected: 0, Updated: 0, Added: 0, All: 0 }
          );

          setStatusCounts(counts);

          setTableData([...execleDat])
        } else {
          setLoading(false);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      setFormError(validationResult);
    }
  };

  return (
    <>
      <Heading title={`${id == 1 ? "LR" : id == 2 ? "JK LR" : id == 3 ? "ADANI LR" : ""} Upload`} download={id == 1 ? "LR" : id == 1 ? "JK_LR" : id == 1 ? "ADANI_LR" : ""} />

      <div className="_Qwk_inr">
        <div className="_tierPart">
          <CustomSelect
            label="Branch"
            placeholder={"Select Branch"}
            options={listData?.branchList}
            value={listData?.branchList?.find(
              (i) => i?.value == form?.branch_id?._id
            )}
            onSelect={(data) => {
              handleOnChange("branch_id", data);

            }}
          />
        </div>
        <div className="_tierPart">

          <CityDropdownForTrip
            key={`Party`}
            label="Party"
            placeholder="Select Party"
            fetchData={fetchConsignor}
            // isAddButton={true}
            // addButtonAction={(e) => addNewItemHandler(e)}
            pageSize={20}
            onChange={(data) => handleOnChange("consignor_id", data)}

            selectedItem={form?.consignor_id}
            error={!!formError["city.name"]}
            errorMessage={
              formError["city.name"]
            }
          // withState={true}
          />
        </div>

        <div className="_tierPart">
          <CustomSelect
            label="Contract"
            placeholder={"Select Contract"}
            options={listData?.contractList}
            value={listData?.contractList?.find(
              (i) => i?.value == form?.contract_id
            )}
            onSelect={(data) => {
              handleOnChange("contract_id", data?.value);
            }}
          />
        </div>

        <div className="_exceluploadBx">
          <CommonInput
            type="file"
            onChange={handleFileChange}
            accept=".csv, .xlsx,.xls"
            error={formError?.file}
          />
        </div>

        <ButtonExcelForQuick name={id == 1 ? "LR" : id == 2 ? "JK_LR" : id == 3 ? "ADANI_LR" : ""} />
        <button
          className="_flUpload_btn"
          disabled={loading}
          onClick={() => handleImportFile()}
        >
          {loading ? "Uploading.." : "Upload File"}
        </button>


      </div>

      {planInportList?.length > 0 && <div className="tbdFilts_bx">
        <div className="_hedFilts">
          <h4>Status</h4> <ExcelDownload tableData={tableData} />
        </div>

        <div className="_tbdOx_bx">
          <div className="_fourTbx">
            <h4>{statusCounts?.All}</h4>
            <p className="__successTxt">All</p>
          </div>

          <div className="_fourTbx">
            <h4>{statusCounts?.Added}</h4>
            <p className="__successTxt">Added</p>
          </div>

          <div className="_fourTbx">
            <h4>{statusCounts?.Updated}</h4>
            <p className="__successTxt">Updated</p>
          </div>

          <div className="_fourTbx">
            <h4>{statusCounts?.Rejected}</h4>
            <p className="__rejectTxe">Not Updated</p>
          </div>
        </div>
      </div>}

      {planInportList?.length > 0 && <div className="_qwkTable_dix">
        <div className="_indentTable _disPatchView _fuelCrd__table">
          <table>
            <thead>
              <tr>
                <th>Unit</th>
                <th>Consignee</th>
                <th>Invoice Number</th>
                <th>GST Invoice Number</th>
                <th>{id == 3 ? "SAP Invoice Number" : "MLR Number"}</th>

                <th>Status</th>
                <th>Remarks</th>
              </tr>
            </thead>

            <tbody>
              {planInportList?.length && planInportList?.map((i, index) => {

                return <tr key={i?.i?.value?.invoice_number}>
                  <td>
                    <div className="_dateNtime _pDate">
                      <p className="_tblText_inDent">{`${i?.value?.unit_code || ""}${i?.value?.unit_code && i?.value?.unit_name ? " | " : ""}${i?.value?.unit_name || ""}`}</p>
                    </div>
                  </td>
                  <td>
                    <div className="_dateNtime _pDate">
                      <p className="_tblText_inDent">{`${i?.value?.consignee_code || ""}${i?.value?.consignee_code && i?.value?.consignee_name ? " | " : ""}${i?.value?.consignee_name || ""}`}</p>
                    </div>
                  </td>
                  <td>
                    <div className="_dateNtime _pDate">
                      <p className="_tblText_inDent">{`${i?.value?.invoice_number || "-"}`}</p>
                    </div>
                  </td>
                  <td>
                    <div className="_dateNtime _pDate">
                      <p className="_tblText_inDent">{`${i?.value?.gst_invoice_number || i?.value?.obd_no || "-"}`}</p>
                    </div>
                  </td>
                  <td>
                    <div className="_dateNtime _pDate">
                      <p className="_tblText_inDent">{`${i?.value?.mlr_number || i?.value?.sap_invoice_number || "-"}`}</p>
                    </div>
                  </td>
                  <td>
                    <div className="_dateNtime _pDate">
                      <p className={`_tblText_inDent${i?.status == "Not Updated" ? " __rejectTxe" : " __successTxt"}`}>{i?.status}</p>
                    </div>
                  </td>

                  <td>
                    <div className="_dateNtime _pDate">
                      <p className="_tblText_inDent">{i?.remarks}</p>
                    </div>
                  </td>
                </tr>
              })}

            </tbody>
          </table>
        </div>
      </div>}
    </>
  );
};

export default LRUpload;
